var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('clist',{attrs:{"title":'客户回访',"req":{回访记录:{'$exists':false}}},on:{"click":_vm.onUserSelect}})}
var staticRenderFns = []

export { render, staticRenderFns }